import React from 'react';
import FormROValue from '../../../library/form/components/FormROValue1';
import FormLink from '../../../library/form/components/FormLink';
import SarasRowSelector from "../../../library/hooks/selector/SarasRowSelector";
import FormWrapper from '../../../library/form/components/FormWrapper';
import SarasCard from '../../../library/repeater/list/SarasCard';
import FormInput from '../../../library/form/components/FormInput';
import SarasTrans from '../../../library/notifications/SarasTrans';

const InvImportItemsRow = (props) => {
    const { formObject, rowKey, rowSelector } = props
    const isSelected = rowSelector && rowSelector.isRowSelected(rowKey);

    return (
        <div className="uiImportItemRow">
            <SarasCard containerClass={`uiCard uiImportItemCard ${isSelected ? 'uiImportItemCardSelected' : ''}`}>
                <div className="uiImportItemGrid">
                    <div className="uiImportItemSelect">
                        <FormWrapper formObject={formObject} rowKey={rowKey} action={{ paramName: "itemSelect" }} >
                            <SarasRowSelector rowSelector={rowSelector} rowID={rowKey}
                                useCheckBox={true} />
                        </FormWrapper>
                    </div>
                    <div className="uiImportItemContent">
                        <div className="uiImportItemMetaChips">
                            <span className="uiImportItemChip">
                                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemType" }} />
                            </span>
                            <span className="uiImportItemChip uiImportItemChipPrimary">
                                <FormLink formObject={formObject} rowKey={rowKey}
                                    action={{
                                        paramName: "itemId",
                                        actionId: "show",
                                        containerKey: "popup"
                                    }}
                                    linkProp={{ target: "_blank" }}
                                ></FormLink>
                            </span>
                        </div>
                        <div className="uiImportItemName">
                            <div className="uiImportItemNameValue">
                                <FormROValue format="#" formObject={formObject} rowKey={rowKey} maxValueLength={100}
                                    className="uiImportItemNameText" action={{ paramName: "itemName" }} />
                            </div>
                        </div>
                    </div>
                    <div className="uiImportItemQty">
                        <div className="uiImportItemQtyRow">
                            <span className="uiImportItemMetaLabel"><SarasTrans value="Pending" /></span>
                            <span className="uiImportItemMetaValue uiImportItemQtyInputs">
                                <FormInput formObject={formObject} className="uiInput uiVal40" rowKey={rowKey}
                                    action={{ InputType: "input", paramName: "value1" }} />
                                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "unit1" }} />
                            </span>
                            <FormWrapper customWrapper="span" wrapperClass="uiImportItemMetaValue uiImportItemQtyInputs" formObject={formObject} rowKey={rowKey} action={{ paramName: "value2" }} >
                                <FormInput formObject={formObject} rowKey={rowKey} className="uiInput uiVal40" 
                                    action={{ InputType: "input", paramName: "value2" }} />
                                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "unit2" }} />
                            </FormWrapper>
                        </div>
                        {/* <div className="uiImportItemQtyRow">
                            <span className="uiImportItemMetaLabel">Unit Cost</span>
                            <span className="uiImportItemMetaValue">
                                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "unitCost" }} />
                            </span>
                        </div> */}
                    </div>
                </div>
            </SarasCard>
        </div>
    )
}

export default InvImportItemsRow
